import {EventEmitter, Injectable} from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class MenuService {
    public itemChanged$: EventEmitter<string[]>;
    public lang$: EventEmitter<string>;
    private menus: string[];
    private lang: string;

    constructor() {
        this.itemChanged$ = new EventEmitter();
        this.lang$ = new EventEmitter();
    }

    public add(menus: string[]): void {
        this.menus = menus;
        this.itemChanged$.emit(menus);
    }

    public changeLang(lang: string): void {
        this.lang = lang;
        this.lang$.emit(lang);
    }


}
